"use client";
import ToolsStack from "@/components/section-infographic/DesignAndDevelopmentAsAService/ToolsStack";
import CaseStudiesMutiPurposeZigZagSection from "@/components/ui/CaseStudiesMutiPurposeZigZagSection";
import CaseStudyEngageMentModel from "@/components/ui/CaseStudyEngageMentModel";
import CommentSection from "@/components/ui/CommentSection";
import CTABanner from "@/components/organisms/CTABanner";
import VideoSection from "@/components/ui/VideoSection";

import CaseStudiesIntroBanner from "@/components/ui/CaseStudiesIntroBanner";
import CaseStudiesNewMegaCardSection from "@/components/ui/CaseStudiesNewMegaCarSection";
import CaseStudiesSkewSatusCardsSection from "@/components/ui/CaseStudiesSkewSatusCardsSection";
import ImageMarquee from "@/components/ui/ImageMarquee";
import SectionTitle from "@/components/ui/SectionTitle";
import IndustryHero from "@/components/SectionHero/IndustryHero";

import RelatedCaseStudies from "@/components/ui/RelatedCaseStudies";
import UniversalTable from "@/components/UniversalTable";
import TheChallengeScrollSection from "@/components/ui/TheChallengeScrollSection";
import RedRibbonBanner from "@/components/ui/RedRibbonBanner";



export default function BoardGamesCasestudyPage() {



    const clients = [

        {
            label: "CLIENT",
            name: "The Chocolate Factory Thailand",

        },
        {
            label: "INDUSTRY",
            name: "Restaurant / Desserts / Food & Beverage / Social Commerce",

        },
        {
            label: "Engagement Type",
            description: "Social Media Marketing & Conversational Commerce",
        },


    ];

    const skewCards = [
        {
            title: "50%+",
            description: "Increase in sales from March to July 2020",
        },
        {
            title: "20%",
            description: "Increase in customers from March to July 2020",
        },
        {
            title: "30%",
            description: "Increase in revenue from March to July 2020",
        },
        {
            title: "263,052",
            description: "Engagements recorded across digital activity",
        },
        {
            title: "1 Lakh",
            description: "Followers achieved",
        },
    ];


    return (
        <main className="overflow-hidden">

            <IndustryHero svgPath="/HeroSectionImg/ChocolateFactoryThailand.svg" />
            <CaseStudiesIntroBanner
                title="How The Chocolate Factory Thailand Grew Online Sales by 50% During the COVID Shift"
                subtitle=""
                imageSrc="/logo/ChoclateFactoryThailand.png"
                imageAlt="Board Games"
            />

            <CaseStudiesSkewSatusCardsSection clients={clients} skewCards={skewCards} clientIntroPara="The Chocolate Factory Thailand, a restaurant and dessert brand known for its wide selection of chocolate sweets, desserts, pizzas, salads, and steaks, needed to quickly adapt when COVID-19 restrictions changed how customers discovered, engaged with, and purchased from restaurants." />

            <section className=" relative overflow-hidden border-y border-[#EDEDED] ">
                < VideoSection src="/video/ChocolateFactory.mp4" poster="/Thumbnails/ChocolateFactoryThailand.png" />
            </section>



            <TheChallengeScrollSection
                sectionTitle={{
                    title: "The Challenge",
                    description: [
                        "The Chocolate Factory Thailand was built around a strong offline dining experience, but the COVID-19 pandemic changed customer behavior almost overnight. With social distancing measures in place, physical restaurant visits became limited, and the brand needed to move quickly toward online sales.",

                        "The challenge was to keep customers engaged, increase online orders, and maintain brand visibility at a time when restaurant discovery was shifting heavily to digital platforms. The brand needed a strategy that could convert its offline reputation into online demand."
                    ],
                }}
                rightColumnItems={[
                    {
                        heading: "Offline Revenue Dependency",
                        text: "The brand’s sales engine was closely tied to physical restaurant visits, making it vulnerable during COVID-led restrictions.",
                    },
                    {
                        heading: "Need for Faster Online Adoption",
                        text: "Customers needed to be guided from dine-in behavior to online ordering and digital engagement.",
                    },
                    {
                        heading: "Social Commerce Opportunity",
                        text: "The brand had strong visual appeal, but this needed to be converted into a more structured social commerce funnel.",
                    },
                    {
                        heading: "Content Consistency Gap",
                        text: "The brand needed regular content, platform-specific creatives and engagement-led messaging to stay visible.",
                    },
                    {
                        heading: "Customer Engagement Gap",
                        text: "With reduced offline interaction, the brand needed new ways to engage customers and influence purchase decisions online.",
                    },
                    {
                        heading: "Follower-to-Sales Conversion Gap",
                        text: "Growing reach and followers was not enough. The strategy had to move users from awareness to action.",
                    },
                ]}
            />
            <div className=" py-16 lg:py-24  relative overflow-hidden">

                <CaseStudiesMutiPurposeZigZagSection
                    sectionTitle="Our Strategic Approach"
                    sectionDescription="MMB created a digital-first growth roadmap to help The Chocolate Factory Thailand shift from offline dependence to online sales momentum. The strategy focused on improving brand visibility, increasing customer engagement and growing social reach through platforms where customers were already active."

                    cards={[
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ChocolateFactoryThailand (1).svg",
                            iconAlt: "Search Visibility",
                            title: "Offline-to-Online Transition",
                            description: "Repositioned digital channels as active sales and engagement touchpoints, not just awareness platforms.",
                            contentAlign: "center",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ChocolateFactoryThailand (3).svg",
                            iconAlt: "Technical SEO Foundation",
                            title: "Social Commerce Strategy",
                            description: "Used social content, messaging, and customer interaction to support online sales of food and desserts.",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ChocolateFactoryThailand (6).svg",
                            iconAlt: "Content Growth",
                            title: "Content Growth",
                            description: "Developed a content strategy focused on product appeal, restaurant recall, seasonal demand, and engagement.",
                            contentAlign: "center",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ChocolateFactoryThailand (4).svg",
                            iconAlt: "Analytics & Optimization",
                            title: "Customer Engagement",
                            description: "Built a system to keep customers engaged through responsive conversations, platform activity, and consistent content.",
                            contentAlign: "center",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ChocolateFactoryThailand (2).svg",
                            iconAlt: "Authority Building Framework",
                            title: "Follower Growth Strategy",
                            description: "Focused on increasing relevant followers while improving brand recall and conversion opportunities.",
                            contentAlign: "center",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ChocolateFactoryThailand (5).svg",
                            iconAlt: "Authority Building Framework",
                            title: "Optimization Lifecycle",
                            description: "Continued to monitor engagement, content response, audience behavior, and campaign performance to refine the strategy.",
                            contentAlign: "center",
                        },
                    ]}
                />

            </div>

            <div className="custom-container pb-16 lg:pb-20 xl:pb-24">
                <CaseStudyEngageMentModel
                    leftImage="/hero-bg/officemeet.jpg"
                    cards={[
                        {
                            title: "Social Commerce Growth Engagement",
                            description: [
                                "A focused engagement designed to help the brand transition from offline restaurant sales to online sales & digital customer engagement.",
                            ],
                        },
                        {
                            title: "Dedicated Growth Pod",
                            description: [
                                "Social media strategist, content planner, creative resource, engagement specialist and performance analyst.",
                            ],
                        },
                        {
                            title: "Optimization Rhythm",
                            description: [
                                "Content performance, audience engagement, follower growth, customer interactions, and online sales impact were monitored regularly.",
                            ],
                        },
                        {
                            title: "Conversion Layer",
                            description: [
                                "Messenger, Instagram Reels, and Facebook Posts were used to support engagement, customer conversations and online sales.",
                            ],
                        },
                    ]}
                />
            </div>


            <div className="section-background-filler py-16 space-y-16">
                <CaseStudiesNewMegaCardSection
                    sectionTitle={{
                        title: "What We Did ",
                        description: "We helped the brand shift from offline dependence to online sales by combining social commerce, content strategy, customer engagement, and platform-led growth. ",
                        align: "left"
                    }}
                    cards={[
                        {
                            title: "Competitor & Customer Research",
                            description:
                                "Studied competitors, customer behavior and digital demand patterns during the COVID-led market shift.",
                        },
                        {
                            title: "Content Strategy",
                            description:
                                "Developed a content and growth strategy focused on online sales, product appeal and customer engagement.",
                        },
                        {
                            title: "Social Media Execution",
                            description:
                                "Created and published platform-specific content across Facebook and Instagram.",
                        },
                        {
                            title: "Conversational Commerce",
                            description:
                                "Used Messenger to engage customers, answer queries and support purchase journeys.",
                        },
                        {
                            title: "Instagram Reels",
                            description:
                                "Leveraged short-form content to showcase products, increase reach and improve engagement.",
                        },
                        {
                            title: "Facebook Posts",
                            description:
                                "Used regular posts to maintain brand visibility, promote offerings and drive customer interest.",
                        },
                        {
                            title: "Follower Growth",
                            description:
                                "Built content and engagement loops to grow the brand’s follower base and improve digital recall.",
                        },
                        {
                            title: "Optimization Lifecycle",
                            description:
                                "Monitored performance and refined content direction based on engagement, audience response and online sales impact.",
                        },
                    ]}

                />

                <div className="mb-12 px-6 md:px-auto xl:my-12">
                    <RedRibbonBanner title="Key Insight:">
                        The Chocolate Factory Thailand did not just need more social media activity. It needed a digital sales bridge that could turn restaurant loyalty, product appeal, and online engagement into measurable revenue growth.
                    </RedRibbonBanner>
                </div>

                <ImageMarquee
                    images={[
                        { src: "/CaseStudiesFolder/ShowCaseImg/ChocolateFactoryThailand/ShowCaseImg (1).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/ChocolateFactoryThailand/ShowCaseImg (2).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/ChocolateFactoryThailand/ShowCaseImg (3).png", alt: "Jem Jem case study" },
                    ]}
                    speed={20}
                    direction="left"
                    pauseOnHover={false}
                />


            </div>



            <section className="py-16 lg:py-20 custom-container">
                <SectionTitle
                    title="The Results "
                    description="The campaign helped The Chocolate Factory Thailand manage its online business more efficiently, engage with customers, and process orders during a period when offline restaurant sales were under pressure."
                    align="center"
                    highlightSubtitle={true}
                />


                <div className="w-full overflow-x-auto mt-6">
                    <div className="inline-block min-w-full align-middle">
                        <div className="grid grid-cols-1  gap-6">
                            <UniversalTable
                                title="Social Commerce Growth Impact"
                                headers={["Metric", "Growth Impact"]}
                                rows={[
                                    ["Sales Growth", "Over 50% increase from March to July 2020"],
                                    ["Customer Growth", "20% increase from March to July 2020"],
                                    ["Revenue Growth", "30% increase from March to July 2020"],
                                    ["Engagements", "263,052 engagements"],
                                    ["Followers", "1 Lakh followers"],
                                    ["Fan Base", "15,000 fans"],
                                ]}
                                ribbonTitle="Key Insight:"
                                ribbonContent="The campaign helped The Chocolate Factory Thailand protect growth during disruption by turning social media into a stronger sales, engagement, and customer retention channel."
                            />

                            <UniversalTable
                                title="Channel impact"
                                headers={["Channel/ Product Used", "Business Role"]}
                                rows={[
                                    [
                                        "Messenger",
                                        "Supported customer conversations, order-related queries, and online engagement.",
                                    ],
                                    [
                                        "Instagram Reels",
                                        "Helped showcase visually appealing products and increase reach.",
                                    ],
                                    [
                                        "Facebook Posts",
                                        "Maintained brand visibility, promoted offerings and supported customer recall.",
                                    ],
                                    [
                                        "Content Strategy",
                                        "Helped move the brand from offline dependence to online sales momentum.",
                                    ],
                                    [
                                        "Engagement Optimization",
                                        "Created consistent audience interaction and stronger digital presence.",
                                    ],
                                ]}
                                ribbonTitle="Key Insight:"
                                ribbonContent="By combining engaging content, conversational commerce, and platform-specific strategies, social channels were converted into high-performing customer touchpoints."
                            />

                            <UniversalTable
                                title="The Impact"
                                headers={["Growth Area", "Impact Delivered"]}
                                rows={[
                                    [
                                        "Online Sales",
                                        "Over 50% increase in sales from March to July 2020.",
                                    ],
                                    [
                                        "Customer Growth",
                                        "20% increase in customers during the campaign period.",
                                    ],
                                    [
                                        "Revenue Performance",
                                        "30% increase in revenue from March to July 2020.",
                                    ],
                                    [
                                        "Social Engagement",
                                        "263,052 engagements generated across digital activity.",
                                    ],
                                    [
                                        "Audience Growth",
                                        "1 Lakh followers and 15,000 fans achieved.",
                                    ],
                                    [
                                        "Digital Transition",
                                        "Helped the brand move from offline-led sales to online customer acquisition.",
                                    ],
                                    [
                                        "Customer Interaction",
                                        "Messenger and social platforms improved brand-customer communication.",
                                    ],
                                ]}
                                ribbonTitle="Key Insight:"
                                ribbonContent=""
                            />
                        </div>
                    </div>
                </div>

            </section>





            <CommentSection quote="When the pandemic shifted customer behavior, MMB helped us quickly adapt our marketing strategy for online growth. Their social media and content approach significantly improved customer engagement and supported our transition from offline dining to online sales." name="Chocolate Factory Thialand" avatarSrc={""} />

            <ToolsStack
                title="Our Tech Stack & Tools "
                description="Our social commerce toolkit combined content, engagement, and performance tracking platforms to convert online interactions into measurable business growth. "
                categories={[
                    {
                        title: "Optimization",
                        items: [
                            "Audience response analysis",
                            "Content optimization",
                            "Engagement optimization",
                        ],
                    },
                    {
                        title: "Content Formats",
                        items: [
                            "Instagram Reels",
                            "Facebook Posts",
                            "Product-led visual content",
                        ],
                    },
                    {
                        title: "Performance Tracking",
                        items: [
                            "Engagement tracking",
                            "Follower growth tracking",
                            "Campaign performance monitoring",
                        ],
                    },
                    {
                        title: "Research & Strategy",
                        items: [
                            "Competitor research",
                            "Customer research",
                            "Content planning",
                            "Growth strategy",
                        ],
                    },
                    {
                        title: "Collaboration & Reporting",
                        items: [
                            "Google Sheets",
                            "Google Drive",
                            "Campaign reporting dashboards",
                        ],
                    },
                  
                    {
                        title: "Social Media Platforms",
                        items: [
                            "Facebook",
                            "Instagram",
                        ],
                    },
                    {
                        title: "Conversational Commerce",
                        items: [
                            "Messenger",
                        ],
                    },
                ]}
                withBackground={true}
            />


            <div className="pb-0 md:pb-16 xl:pb-20 relative overflow-hidden">
                <CTABanner
                    title="Let’s Turn Social Engagement into Sales!"
                    description="For food, restaurant and lifestyle brands, social media can become a direct growth channel."
                    buttonText="Schedule a Consultation"
                    // buttonOnClick={handleCTAButtonClick}
                    bgColor="#313866"
                    textColor="#fff"
                    buttonVariant="primary"
                />
            </div>
            <RelatedCaseStudies />
        </main >
    );
}